/* eslint-disable camelcase */
import PropTypes from 'prop-types';

import {
  propTypesIllustration,
  propTypesLink,
} from '../../../constants/Proptypes';

const propTypesSliceFeaturePresentationHomepage = {
  feature_presentation_slice_id: PropTypes.string,
  is_reverse: PropTypes.bool,
  feature_presentation_intro: PropTypes.string,
  feature_presentation_title: PropTypes.string,
  feature_presentation_cta_label: PropTypes.string,
  feature_presentation_cta_link: PropTypes.shape(propTypesLink),
  feature_presentation_cta_datatrack: PropTypes.string,
};

const propTypesItemsFeaturePresentationHomepage = {
  feature_link: PropTypes.shape(propTypesLink),
  feature_name: PropTypes.string,
  feature_picture: PropTypes.shape(propTypesIllustration),
};

export const propTypesDataFeaturePresentationHomepage = {
  id: PropTypes.string,
  slice_type: PropTypes.string,
  slice_label: PropTypes.string,
  primary: PropTypes.shape(propTypesSliceFeaturePresentationHomepage),
  items: PropTypes.arrayOf(
    PropTypes.shape(propTypesItemsFeaturePresentationHomepage)
  ),
};
